import { Checkbox, InputLabel, MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { getDepartmentSchedules } from "../../api/department_schedule";
import { getScheduleTypes } from "../../api/schedule_types";
import { useCalendar } from "../../hooks/useCalendar";
import CommonCalendar from "./CommonCalendar";
import { OnDutyRequestMemoList } from "./OnDutyRequestMemoList";
import ScheduleEdit from "./ScheduleEditByType";

export default function CalendarByType() {
  const [scheduleTypeIds, setScheduleTypeIds] = useState([1]);

  const {
    pivot,
    setSchedules,
    open,
    scheduleData,
    scheduleDate,
    scheduleByDate,
    scheduleMap,
    handleClickOpen,
    handleClose,
    handleThisMonth,
    handleNextMonth,
    handlePrevMonth,
    canAllDay,
    checkRegister,
  } = useCalendar();

  const { data: scheduleTypes, isSuccess: isSuccessScheduleType } = useQuery({
    queryKey: ["scheduleTypes"],
    queryFn: () => getScheduleTypes(),
    throwOnError: true,
  });

  const { data: schedules, isSuccess: isSuccessSchedules } = useQuery({
    queryKey: ["scheduleByType", pivot, scheduleTypeIds],
    queryFn: () =>
      getDepartmentSchedules(
        pivot.format("YYYY"),
        pivot.format("MM"),
        scheduleTypeIds,
      ),
    throwOnError: true,
    enabled: true,
  });

  useEffect(() => {
    if (isSuccessScheduleType) {
      setScheduleTypeIds([scheduleTypes[0]?.id]);
    }
  }, [isSuccessScheduleType, scheduleTypes]);

  useEffect(() => {
    if (isSuccessSchedules) {
      setSchedules(schedules);
    }
  }, [isSuccessSchedules, schedules, setSchedules]);

  const handleChangeScheduleType = useCallback((event) => {
    const {
      target: { value },
    } = event;
    setScheduleTypeIds(
      typeof value === "string" ? value.split(",") : value.length ? value : [],
    );
  }, []);

  const renderScheduleTypeSelector = () => (
    <Box sx={{ maxWidth: "200px", marginLeft: "12px" }}>
      <InputLabel id="schedule_type_label">スケジュール種別</InputLabel>
      <Select
        variant="outlined"
        sx={{ marginBottom: "10px", width: 350 }}
        autoFocus
        multiple
        labelId="schedule_type_label"
        id="schedule_type_id"
        name="schedule_type_id"
        fullWidth
        onChange={handleChangeScheduleType}
        value={scheduleTypeIds ?? []}
        renderValue={(selected) => {
          const types = scheduleTypes ? scheduleTypes : [];
          return types
            .filter((s) => selected.includes(s.id))
            .map((s) => s.name)
            .join(",");
        }}
      >
        {scheduleTypes?.map((scheduleType, i) => (
          <MenuItem value={scheduleType.id} key={scheduleType.id}>
            <Checkbox checked={scheduleTypeIds.indexOf(scheduleType.id) > -1} />
            {scheduleType.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );

  const cellStyles = {
    borderLeft: 1,
    borderTop: 1,
    borderColor: "#999",
    width: "100%",
    paddingTop: "4px",
    paddingBottom: "4px",
  };

  return (
    <>
      <ScheduleEdit
        key={Date.now()}
        isNew={scheduleData === null}
        date={scheduleDate}
        obj={scheduleData}
        byDate={scheduleByDate}
        open={open}
        onClose={handleClose}
        canAllDay={canAllDay}
        checkRegister={checkRegister}
        paramScheduleTypeId={
          scheduleData?.schedule_type_id ?? scheduleTypeIds[0]
        }
      />

      <CommonCalendar
        pivot={pivot}
        handleThisMonth={handleThisMonth}
        handlePrevMonth={handlePrevMonth}
        handleNextMonth={handleNextMonth}
        renderScheduleTypeSelector={renderScheduleTypeSelector}
        scheduleMap={scheduleMap}
        handleClickOpen={handleClickOpen}
        cellStyles={cellStyles}
      />

      <Box sx={{ marginTop: "15px" }}>
        <OnDutyRequestMemoList pivot={pivot} />
      </Box>
    </>
  );
}
